import { GENRES } from "../constants/genres";
import {
  Actor,
  FetchedActor,
  FetchedMovie,
  MovieDetail,
  MovieItem,
  NowPlayingMovie,
  SelectOption,
} from "../constants/interfaces";

export const getYearOptions = (startYear: number) => {
  const defaultOption: SelectOption = { value: 0, label: "All Years" };
  const currentYear = new Date().getFullYear();
  const options = Array(currentYear - startYear + 1)
    .fill(undefined)
    .map((_, idx) => currentYear - idx);

  const yearOptions = [
    defaultOption,
    ...(options.map((option) => ({ value: option, label: `${option}` })) as SelectOption[]),
  ];

  return yearOptions;
};

const getCommonMovieInfo = (fetchedMovie: FetchedMovie) => {
  return {
    id: fetchedMovie.id,
    title: fetchedMovie.title,
    releaseYear: new Date(fetchedMovie.release_date).getFullYear(),
  };
};

export const getNowPlayingMovie = (fetchedMovie: FetchedMovie) => {
  return {
    ...getCommonMovieInfo(fetchedMovie),
    overview: fetchedMovie.overview,
    backdrop: fetchedMovie.backdrop_path,
    genres: fetchedMovie.genre_ids!.map((id) => GENRES.find((genre) => genre.id === id)?.name),
  } as NowPlayingMovie;
};

export const getMovieItem = (fetchedMovie: FetchedMovie) => {
  return {
    ...getCommonMovieInfo(fetchedMovie),
    poster: fetchedMovie.poster_path,
    genre: fetchedMovie.genre_ids!.map((id) => GENRES.find((genre) => genre.id === id)?.name),
  } as MovieItem;
};

export const getMovieDetail = (fetchedMovie: FetchedMovie) => {
  const videoResults = fetchedMovie.videos?.results.filter(
    (result) => result.site === "YouTube" || result.site === "Vimeo"
  );
  const trailerVideoLink =
    videoResults?.find((result) => result.type === "Trailer") ||
    videoResults?.find((result) => result.type === "Teaser");

  return {
    ...getCommonMovieInfo(fetchedMovie),
    backdrop: fetchedMovie.backdrop_path,
    poster: fetchedMovie.poster_path,
    genres: fetchedMovie.genres!.map((genre) => genre.name),
    overview: fetchedMovie.overview,
    trailerId: trailerVideoLink?.key,
    trailerSite: trailerVideoLink?.site.toLowerCase(),
    rating: +(fetchedMovie.vote_average / 2).toFixed(1),
  } as MovieDetail;
};

export const getActor = (fetchedActor: FetchedActor) => {
  return {
    realName: fetchedActor.name,
    characterName: fetchedActor.character,
    photo: fetchedActor.profile_path,
  } as Actor;
};
